import { IDropdown } from '../../models/dropdown/IDropdown';
import { IFacet } from '../../models/IFacet';
import { replaceAttrSpaceWithHyphen } from '../string-helpers/replace-attr-space-with-hyphen';

export const createDropdownOptions = (
  facets: IFacet[],
  facetId: string,
  defaultText: string,
): IDropdown[] => {
  const facet = facets.find((item) => item.id === facetId);
  if (!facet) return [];

  const options: IDropdown[] =
    facet.values.length > 1
      ? [
          {
            text: defaultText,
            id: 'all',
            default: true,
            value: 'all',
          },
        ]
      : [];

  return options.concat(
    facet.values.map((item) => ({
      text: item,
      id: replaceAttrSpaceWithHyphen(item),
      default: false,
      value: item,
    })),
  );
};
